import React from "react"
import { Form, Input, Select } from "antd"
import type { FormItemProps } from "antd"
import type { CSSProperties, ReactNode } from "react"

type Props = {
  label?: ReactNode
  name: string
  control: "input" | "select"
  placeholder?: string
  prefix?: ReactNode
  options?: Array<{ label: ReactNode; value: string | number }>
  allowClear?: boolean
  rules?: Array<Record<string, unknown>>
  className?: string
  inputClassName?: string
  selectClassName?: string
  maxLength?: number
  suffix?: ReactNode
  selectLoading?: boolean
  showSearch?: boolean
  optionFilterProp?: string
  noStyle?: boolean
  normalize?: FormItemProps["normalize"]
  inputStyle?: CSSProperties
  selectStyle?: CSSProperties
}

const CustomInput: React.FC<Props> = ({
  label,
  name,
  control,
  placeholder,
  prefix,
  options,
  allowClear,
  rules,
  className,
  inputClassName,
  selectClassName,
  maxLength,
  suffix,
  selectLoading,
  showSearch,
  optionFilterProp,
  noStyle,
  normalize,
  inputStyle,
  selectStyle,
}) => {
  const selectShowSearch = showSearch ?? true
  const selectOptionFilterProp = optionFilterProp ?? "label"

  const formItemClassName = noStyle
    ? undefined
    : className
    ? `${className}`
    : "[&_.ant-form-item-label>label]:font-circular [&_.ant-form-item-label>label]:text-[#0F172B]"

  return (
    <Form.Item
      label={noStyle ? undefined : label}
      name={name}
      rules={rules}
      className={formItemClassName}
      noStyle={noStyle}
      normalize={normalize}
    >
      {control === "input" ? (
        <Input
          placeholder={placeholder}
          prefix={prefix}
          maxLength={maxLength}
          suffix={suffix}
          style={inputStyle}
          className={`h-10 rounded-lg${
            inputClassName ? ` ${inputClassName}` : ""
          }`}
        />
      ) : (
        <Select
          placeholder={placeholder}
          allowClear={allowClear}
          options={options}
          loading={selectLoading}
          showSearch={selectShowSearch}
          optionFilterProp={selectOptionFilterProp}
          suffixIcon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m19.5 8.25-7.5 7.5-7.5-7.5"
              />
            </svg>
          }
          style={
            selectStyle || {
              display: "flex",
              alignItems: "center",
              width: "100%",
            }
          }
          className={`[&_.ant-select-selector]:!h-10 [&_.ant-select-selector]:!rounded-lg${
            selectClassName ? ` ${selectClassName}` : ""
          }`}
        />
      )}
    </Form.Item>
  )
}

export default CustomInput
